import React from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { LocalizedLink } from './LocalizedLink';
import { getDemoBookingUrl, trackDemoEvent } from '../utils/matomo';

/**
 * Primary register + secondary demo CTAs for public SEO pages.
 */
export default function PublicConversionCtas({
  onRegisterClick,
  sourcePath,
  size = 'lg',
  className = 'd-flex flex-column flex-sm-row gap-3 justify-content-center',
  registerVariant = 'light',
}) {
  const { t } = useTranslation('landing');

  const handleDemoClick = () => {
    trackDemoEvent(sourcePath);
  };

  return (
    <div className={className}>
      <Button
        as={LocalizedLink}
        to="/register/"
        variant={registerVariant}
        size={size}
        className="fw-semibold"
        onClick={onRegisterClick}
      >
        <i className="bi bi-play-circle-fill me-2" />
        {t('hero.cta')}
      </Button>
      <Button
        href={getDemoBookingUrl()}
        target="_blank"
        rel="noopener noreferrer"
        variant="outline-light"
        size={size}
        className="fw-semibold"
        onClick={handleDemoClick}
      >
        <i className="bi bi-calendar-check me-2" />
        {t('hero.demoCta')}
      </Button>
    </div>
  );
}
